// Tabs inside an offcanvas or a modal (template docs cards.md "Tabs in an
// offcanvas"): the container's footer holds ONE button row per pane -
// `[tab-footer="#paneId"]` - and only the active pane's row shows (a pane
// whose controls save themselves has no row; the footer folds away when
// no row is visible - scss). Delegated: nothing to wire per page.
function syncFooters(container) {
	const active = container.querySelector('.tab-pane.active');
	container.querySelectorAll('[tab-footer]').forEach((row) => {
		const target = row.getAttribute('tab-footer');
		row.hidden = !active || !target || !active.matches(target);
	});
}

export function initTabs() {
	const containerOf = (el) => el && el.closest('.offcanvas, .modal, .card');
	document.addEventListener('shown.bs.tab', (e) => {
		const targetSel = e.target.getAttribute('data-bs-target') || e.target.getAttribute('href');
		const pane = targetSel ? document.querySelector(targetSel) : null;
		const container = containerOf(pane);
		if (container) syncFooters(container);
	});
	// the initial state: at load, and when a container opens (its panes may
	// have been reset by the page meanwhile)
	const syncAll = () => document.querySelectorAll('[tab-footer]').forEach((row) => { const c = containerOf(row); if (c) syncFooters(c); });
	syncAll();
	['show.bs.offcanvas', 'show.bs.modal'].forEach((ev) => document.addEventListener(ev, (e) => syncFooters(e.target)));
}
